var _rect, _path, _path2, _text, _path3, _path4, _text2, _path5, _path6, _rect2, _path7, _path8, _path9, _text3, _rect3, _text4, _rect4, _text5, _image, _g, _rect5, _rect6, _text6, _rect7, _rect8, _text7, _path10, _path11, _rect9, _path12, _text8, _rect10, _text9, _rect11, _image2, _path13, _path14, _rect12, _path15, _path16, _path17, _text10, _rect13, _path18, _path19, _path20, _rect14, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _text11, _path28, _path29, _text12, _path30, _path31, _br, _text13, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _text14, _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabaseArch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1191px",
    height: "1050px",
    viewBox: "-0.5 -0.5 1191 1050",
    content: "<mxfile host=\"Electron\" modified=\"2022-03-17T03:37:23.946Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/16.5.1 Chrome/96.0.4664.110 Electron/16.0.7 Safari/537.36\" etag=\"ofnyD8MhxcQst3HAO2xi\" version=\"16.5.1\" type=\"device\"><diagram id=\"PFhKEQPplIHCdk-R_g99\" name=\"Page-1\">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</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-f78e04-1-d05c17-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(208, 92, 23)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(247, 142, 4)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-945df2-1-5a30b5-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(90, 48, 181)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(148, 93, 242)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 566,
    width: 1000,
    height: 482.31,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 190 86 L 1190 86 L 1190 526 L 190 526 Z",
    fill: "none",
    stroke: "#232f3e",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 196.09 93.18 C 196.01 93.18 195.93 93.19 195.85 93.19 C 195.5 93.19 195.15 93.23 194.81 93.32 C 194.53 93.39 194.25 93.49 193.98 93.62 C 193.9 93.65 193.84 93.7 193.79 93.76 C 193.75 93.83 193.74 93.91 193.74 93.99 L 193.74 94.32 C 193.74 94.46 193.78 94.53 193.88 94.53 L 193.99 94.53 L 194.22 94.44 C 194.45 94.35 194.69 94.27 194.94 94.21 C 195.17 94.16 195.41 94.13 195.65 94.13 C 196.04 94.09 196.43 94.2 196.74 94.44 C 196.97 94.74 197.09 95.12 197.05 95.5 L 197.05 95.99 C 196.78 95.93 196.54 95.88 196.29 95.84 C 196.05 95.81 195.81 95.79 195.57 95.79 C 194.98 95.76 194.4 95.94 193.94 96.31 C 193.54 96.65 193.32 97.15 193.34 97.68 C 193.31 98.15 193.49 98.62 193.82 98.96 C 194.18 99.29 194.66 99.46 195.15 99.44 C 195.91 99.45 196.63 99.11 197.11 98.51 C 197.18 98.66 197.24 98.79 197.31 98.91 C 197.38 99.02 197.46 99.12 197.55 99.21 C 197.6 99.27 197.67 99.31 197.75 99.31 C 197.81 99.31 197.87 99.29 197.92 99.25 L 198.34 98.97 C 198.41 98.93 198.46 98.86 198.47 98.77 C 198.47 98.72 198.45 98.67 198.42 98.62 C 198.34 98.47 198.26 98.31 198.21 98.14 C 198.15 97.95 198.12 97.75 198.13 97.55 L 198.14 95.37 C 198.2 94.77 198 94.18 197.59 93.74 C 197.17 93.39 196.64 93.19 196.09 93.18 Z M 209.89 93.19 C 209.78 93.19 209.68 93.19 209.57 93.2 C 209.29 93.2 209 93.24 208.73 93.31 C 208.47 93.38 208.23 93.5 208.01 93.66 C 207.82 93.81 207.66 93.99 207.54 94.21 C 207.42 94.43 207.35 94.67 207.36 94.92 C 207.36 95.27 207.48 95.61 207.69 95.89 C 207.97 96.22 208.34 96.46 208.76 96.56 L 209.72 96.87 C 209.97 96.93 210.2 97.05 210.39 97.22 C 210.51 97.35 210.58 97.51 210.57 97.69 C 210.58 97.94 210.45 98.18 210.23 98.31 C 209.93 98.48 209.6 98.56 209.26 98.54 C 208.99 98.54 208.72 98.51 208.46 98.45 C 208.22 98.4 207.98 98.32 207.75 98.22 L 207.59 98.15 C 207.54 98.14 207.5 98.14 207.46 98.15 C 207.36 98.15 207.31 98.22 207.31 98.36 L 207.31 98.69 C 207.31 98.76 207.32 98.82 207.35 98.89 C 207.4 98.97 207.47 99.03 207.56 99.07 C 207.8 99.19 208.06 99.28 208.32 99.34 C 208.66 99.41 209 99.45 209.35 99.45 L 209.33 99.46 C 209.66 99.45 209.98 99.4 210.29 99.3 C 210.55 99.22 210.8 99.09 211.01 98.92 C 211.21 98.77 211.38 98.57 211.49 98.34 C 211.61 98.1 211.67 97.83 211.66 97.56 C 211.67 97.23 211.56 96.9 211.36 96.63 C 211.09 96.32 210.73 96.09 210.33 95.99 L 209.39 95.69 C 209.13 95.61 208.88 95.49 208.67 95.32 C 208.54 95.2 208.47 95.03 208.47 94.85 C 208.46 94.61 208.58 94.38 208.79 94.25 C 209.06 94.11 209.36 94.05 209.67 94.06 C 210.11 94.06 210.55 94.14 210.96 94.32 C 211.04 94.37 211.12 94.4 211.21 94.41 C 211.31 94.41 211.36 94.34 211.36 94.19 L 211.36 93.88 C 211.37 93.8 211.35 93.72 211.31 93.66 C 211.25 93.59 211.18 93.54 211.11 93.49 L 210.83 93.38 L 210.45 93.27 L 210.01 93.2 C 209.97 93.2 209.93 93.19 209.89 93.19 Z M 206.02 93.36 C 205.94 93.35 205.86 93.38 205.79 93.42 C 205.72 93.5 205.68 93.59 205.66 93.69 L 204.51 98.14 L 203.47 93.71 C 203.45 93.61 203.41 93.52 203.34 93.44 C 203.26 93.39 203.17 93.37 203.07 93.38 L 202.54 93.38 C 202.44 93.37 202.35 93.39 202.27 93.44 C 202.2 93.51 202.15 93.61 202.14 93.71 L 201.09 98.14 L 199.97 93.7 C 199.95 93.6 199.91 93.51 199.84 93.44 C 199.76 93.39 199.67 93.36 199.58 93.37 L 198.92 93.37 C 198.81 93.37 198.76 93.43 198.76 93.54 C 198.77 93.63 198.79 93.72 198.82 93.81 L 200.38 98.95 C 200.4 99.05 200.45 99.14 200.52 99.21 C 200.6 99.26 200.69 99.29 200.78 99.28 L 201.36 99.26 C 201.46 99.27 201.55 99.25 201.63 99.19 C 201.7 99.12 201.74 99.03 201.76 98.93 L 202.79 94.64 L 203.82 98.93 C 203.83 99.03 203.88 99.12 203.95 99.19 C 204.03 99.25 204.12 99.27 204.21 99.26 L 204.78 99.26 C 204.88 99.27 204.97 99.25 205.04 99.2 C 205.11 99.13 205.16 99.03 205.18 98.94 L 206.79 93.79 C 206.84 93.72 206.84 93.63 206.84 93.63 C 206.84 93.59 206.84 93.56 206.84 93.52 C 206.84 93.48 206.82 93.43 206.79 93.4 C 206.76 93.37 206.72 93.35 206.67 93.36 L 206.05 93.36 C 206.04 93.36 206.03 93.36 206.02 93.36 Z M 195.65 96.62 C 195.7 96.62 195.75 96.62 195.8 96.62 L 196.43 96.62 C 196.64 96.64 196.85 96.67 197.06 96.71 L 197.06 97.01 C 197.07 97.21 197.05 97.4 197 97.59 C 196.96 97.75 196.88 97.9 196.77 98.01 C 196.61 98.21 196.39 98.36 196.14 98.44 C 195.91 98.52 195.67 98.56 195.43 98.56 C 195.18 98.6 194.93 98.53 194.73 98.37 C 194.55 98.18 194.46 97.92 194.49 97.66 C 194.47 97.36 194.59 97.08 194.81 96.89 C 195.06 96.72 195.35 96.62 195.65 96.62 Z M 211.04 100.72 C 210.34 100.73 209.51 100.89 208.88 101.33 C 208.69 101.47 208.72 101.63 208.94 101.63 C 209.64 101.54 211.21 101.35 211.5 101.71 C 211.78 102.06 211.19 103.54 210.94 104.21 C 210.86 104.41 211.03 104.49 211.21 104.34 C 212.39 103.36 212.72 101.3 212.46 101 C 212.32 100.85 211.74 100.71 211.04 100.72 Z M 192.65 101.1 C 192.5 101.12 192.42 101.3 192.58 101.44 C 195.29 103.89 198.82 105.23 202.48 105.21 C 205.37 105.22 208.2 104.36 210.59 102.74 C 210.95 102.47 210.63 102.07 210.26 102.23 C 207.87 103.24 205.3 103.76 202.71 103.77 C 199.23 103.78 195.82 102.87 192.81 101.14 C 192.75 101.11 192.69 101.1 192.65 101.1 Z M 190 86 L 215 86 L 215 111 L 190 111 Z",
    fill: "#232f3e",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 968,
      height: 1,
      paddingTop: 93,
      marginLeft: 222
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "AWS Cloud")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 222,
    y: 105,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "AWS Cloud")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 220 112 L 1170 112 L 1170 506 L 220 506 Z",
    fill: "none",
    stroke: "#248814",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 230.59 118.65 C 230.53 118.65 230.48 118.65 230.42 118.65 L 230.42 118.65 C 229.11 118.68 228.03 119.24 227.14 120.25 C 227.13 120.25 227.13 120.25 227.13 120.25 C 226.2 121.36 225.87 122.52 225.96 123.73 C 224.81 124.06 224.12 124.92 223.76 125.74 C 223.75 125.75 223.75 125.76 223.74 125.78 C 223.33 127.05 223.68 128.36 224.24 129.16 C 224.25 129.17 224.25 129.17 224.26 129.18 C 224.94 130.05 225.97 130.53 227.02 130.53 L 238.17 130.53 C 239.19 130.53 240.07 130.16 240.8 129.37 C 241.25 128.94 241.49 128.29 241.58 127.59 C 241.67 126.9 241.61 126.16 241.32 125.55 C 241.31 125.54 241.31 125.53 241.31 125.52 C 240.8 124.62 239.95 123.81 238.76 123.64 C 238.74 122.79 238.28 121.99 237.68 121.56 C 237.67 121.55 237.66 121.55 237.65 121.54 C 237.01 121.18 236.4 121.14 235.91 121.3 C 235.6 121.4 235.36 121.56 235.14 121.74 C 234.51 120.36 233.43 119.18 231.81 118.79 C 231.81 118.79 231.81 118.79 231.81 118.79 C 231.38 118.7 230.97 118.65 230.59 118.65 Z M 230.43 119.38 C 230.8 119.38 231.2 119.43 231.64 119.53 C 233.16 119.89 234.15 121.07 234.66 122.48 C 234.71 122.6 234.81 122.69 234.94 122.72 C 235.07 122.74 235.2 122.7 235.29 122.61 C 235.54 122.34 235.83 122.11 236.14 122.01 C 236.44 121.91 236.78 121.92 237.26 122.18 C 237.67 122.49 238.11 123.31 238.03 123.9 C 238.01 124.01 238.05 124.12 238.12 124.2 C 238.19 124.28 238.29 124.33 238.39 124.33 C 239.46 124.34 240.16 125.02 240.64 125.88 C 240.85 126.3 240.91 126.92 240.84 127.5 C 240.76 128.07 240.53 128.59 240.28 128.83 C 240.27 128.84 240.27 128.85 240.26 128.85 C 239.65 129.53 239.03 129.78 238.17 129.78 L 227.02 129.78 C 226.2 129.78 225.39 129.41 224.85 128.73 C 224.44 128.13 224.14 127.02 224.46 126.02 C 224.79 125.27 225.36 124.55 226.41 124.36 C 226.6 124.32 226.74 124.14 226.71 123.94 C 226.56 122.79 226.8 121.81 227.7 120.74 C 228.49 119.85 229.33 119.39 230.43 119.38 Z M 232.2 122.7 C 231.77 122.7 231.4 122.93 231.13 123.21 C 230.85 123.5 230.64 123.85 230.64 124.25 L 230.64 124.71 L 230.14 124.71 C 230.04 124.71 229.94 124.75 229.87 124.82 C 229.8 124.89 229.76 124.98 229.76 125.08 L 229.76 127.7 C 229.76 127.8 229.8 127.89 229.87 127.96 C 229.94 128.03 230.04 128.07 230.14 128.07 L 234.16 128.07 C 234.26 128.07 234.35 128.03 234.42 127.96 C 234.49 127.89 234.53 127.8 234.53 127.7 L 234.53 125.08 C 234.53 124.98 234.49 124.89 234.42 124.82 C 234.35 124.75 234.26 124.71 234.16 124.71 L 233.68 124.71 L 233.68 124.25 C 233.68 123.84 233.47 123.47 233.21 123.2 C 232.94 122.92 232.61 122.7 232.2 122.7 Z M 232.2 123.45 C 232.29 123.45 232.5 123.54 232.67 123.72 C 232.83 123.89 232.93 124.11 232.93 124.25 L 232.93 124.71 L 231.39 124.71 L 231.39 124.25 C 231.39 124.15 231.49 123.91 231.66 123.74 C 231.83 123.56 232.06 123.45 232.2 123.45 Z M 230.51 125.46 L 233.78 125.46 L 233.78 127.32 L 230.51 127.32 Z M 220 137 L 220 112 L 245 112 L 245 137 Z",
    fill: "#248814",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 918,
      height: 1,
      paddingTop: 119,
      marginLeft: 252
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #AAB7B8; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(170, 183, 184)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "VPC")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 252,
    y: 131,
    fill: "#AAB7B8",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "VPC")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 194.39 416 C 174.84 416 160.02 399.9 160.02 382.1 L 160 377.96 C 160 360.43 174.68 344 194.45 344 C 214.69 344 229 360.49 229 378.21 L 229 382.17 C 229 399.22 214.69 416 194.39 416 Z",
    fill: "#f58534",
    stroke: "none",
    pointerEvents: "all"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 160 377.96 C 160 400.45 178.26 413.05 193.8 413.05 C 215.68 413.05 229 395.83 229 378.21 L 229 382.17 C 229 399.16 214.67 416 194.39 416 C 174.84 416 160.02 399.87 160.02 382.1 Z",
    fillOpacity: 0.3,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 344,
    width: 0,
    height: 0,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 209.39 387.94 C 213.66 387.85 216.68 384.91 216.97 382.08 C 217.39 379.01 214.49 374.78 210.24 374.33 L 208.24 374.19 L 208.12 372.04 C 208 370.76 207.18 369.01 205.27 368.41 C 202.78 367.7 201.73 368.82 199.49 370.35 L 198.31 367.89 C 197.04 365.17 193.85 361.94 188.83 361.82 C 182.68 361.85 178.38 366.97 178.38 372.29 L 178.4 374.22 L 176.66 374.71 C 174.75 375.34 171.95 378.11 172.03 381.7 C 172.09 385.43 176.19 387.94 179.64 387.94 Z M 179.78 391.58 C 174.19 391.58 168.88 387.75 168.52 382.49 C 167.94 376.92 172.32 372.66 174.86 371.6 C 175.19 366.06 178.37 362.26 181.61 360.31 C 185.95 357.72 190.94 357.78 194.98 359.75 C 197.03 360.69 199.27 362.5 200.87 365.23 C 202.84 364.29 205.82 364.18 208.36 365.94 C 210.15 367.23 211.17 369.01 211.52 370.92 C 216.55 371.83 221.45 377.1 220.36 383.29 C 219.71 387.52 214.72 391.58 209.34 391.58 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 250 142 L 1130 142 L 1130 486 L 250 486 Z",
    fill: "#e9f3e6",
    stroke: "none",
    pointerEvents: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 250 142 L 275 142 L 275 167 L 250 167 Z M 262.52 145.21 C 261.4 145.21 260.31 145.63 259.49 146.39 C 258.67 147.11 258.2 148.15 258.2 149.24 L 258.2 151.78 L 255.89 151.78 C 255.8 151.78 255.7 151.82 255.64 151.89 C 255.57 151.95 255.54 152.04 255.54 152.13 L 255.54 163.43 C 255.54 163.63 255.7 163.79 255.89 163.79 L 269.11 163.79 C 269.3 163.79 269.46 163.63 269.46 163.43 L 269.46 152.15 C 269.47 152.06 269.43 151.97 269.36 151.9 C 269.3 151.83 269.21 151.79 269.11 151.79 L 266.81 151.79 L 266.81 149.29 C 266.8 148.21 266.35 147.18 265.56 146.44 C 264.74 145.65 263.65 145.22 262.52 145.21 Z M 262.51 145.93 C 263.46 145.92 264.37 146.28 265.06 146.93 C 265.72 147.54 266.1 148.4 266.1 149.29 L 266.1 151.79 L 258.88 151.79 L 258.89 149.26 C 258.9 148.36 259.28 147.51 259.95 146.91 C 260.65 146.27 261.57 145.92 262.51 145.93 Z M 256.24 152.5 L 268.76 152.5 L 268.75 163.07 L 256.24 163.07 Z M 262.51 154.74 C 261.48 154.73 260.61 155.51 260.51 156.53 C 260.42 157.56 261.13 158.48 262.14 158.66 L 262.14 161.44 L 262.86 161.44 L 262.86 158.66 C 263.79 158.49 264.47 157.67 264.48 156.72 C 264.48 155.63 263.6 154.75 262.51 154.74 Z M 262.39 155.45 C 262.43 155.45 262.47 155.45 262.51 155.46 C 262.84 155.46 263.16 155.59 263.4 155.83 C 263.64 156.07 263.77 156.39 263.76 156.72 C 263.77 157.06 263.64 157.38 263.4 157.61 C 263.16 157.85 262.84 157.98 262.51 157.98 C 262.04 158.02 261.6 157.8 261.34 157.42 C 261.08 157.03 261.06 156.53 261.28 156.12 C 261.5 155.71 261.93 155.46 262.39 155.45 Z",
    fill: "#248814",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 848,
      height: 1,
      paddingTop: 149,
      marginLeft: 282
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #248814; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(36, 136, 20)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Public subnet")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 282,
    y: 161,
    fill: "#248814",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Public subnet")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 112,
    width: 90,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 127,
      marginLeft: 271
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "10.0.0.0/16")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 315,
    y: 131,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "10.0.0.0/16")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 142,
    width: 90,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 157,
      marginLeft: 351
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "10.0.1.0/24")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 161,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "10.0.1.0/24")))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 289.5,
    y: 345.5,
    width: 74.33,
    height: 74,
    xlinkHref: "data:image/jpeg;base64,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",
    preserveAspectRatio: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "12px"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "rgb(255, 255, 255)",
    stroke: "none",
    x: 299,
    y: 427,
    width: 57,
    height: 15,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("text", {
    x: 326.66,
    y: 437.5
  }, "ProxySQL"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 166,
    width: 513,
    height: 860,
    fillOpacity: 0.5,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 179.19,
    width: 80,
    height: 25.96,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 192,
      marginLeft: 571
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "HID: 30 (Reader)")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 197,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "middle"
  }, "HID: 30 (R...")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 211.01,
    width: 340,
    height: 164.39,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 229.69,
    width: 59.13,
    height: 14.79,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 57,
      height: 1,
      paddingTop: 237,
      marginLeft: 641
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "HID: 10 (Writer)")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 670,
    y: 242,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "middle"
  }, "HID: 10...")))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 792 286.45 L 792 288.88 C 792 289.67 789.3 290.44 787.73 290.7 C 783.15 291.63 775.94 291.49 772.56 290.78 C 770.82 290.47 767.8 289.68 767.8 288.89 L 767.8 286.42 C 767.88 285.63 770.67 284.74 773.54 284.37 C 777.76 283.86 781.82 283.87 785.32 284.26 C 787.86 284.48 791.97 285.45 792 286.45 Z M 792 291.35 L 792 310.54 C 791.82 311.28 788.37 312.2 786.91 312.35 C 781.89 313.12 775.78 313.19 771.21 312.22 C 769.69 311.9 767.79 311.21 767.8 310.44 L 767.8 291.15 C 768.75 291.82 770.38 292.41 773.3 292.9 C 776.65 293.47 782.53 293.5 786.79 292.83 C 789.04 292.5 790.97 291.92 792 291.35 Z M 766.44 311.84 L 742.17 311.84 C 736.92 311.84 732 307.92 732 303.05 L 732 266.11 C 732 261.2 737.05 257.39 742.12 257.39 L 781.61 257.39 C 788.24 257.39 792 262.16 792 266.36 L 792 283.59 C 790.49 282.9 787.41 282.21 784.54 281.96 C 779.45 281.47 773.98 281.69 770.26 282.38 C 767.82 282.8 764.52 283.78 764.52 284.66 L 764.52 308.07 C 764.52 308.63 765.61 309.32 766.44 309.57 Z",
    fill: "#2e73b8",
    stroke: "none",
    pointerEvents: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 792 281.42 L 792 283.59 C 790.49 282.89 787.41 282.22 784.54 281.96 C 779.46 281.48 773.99 281.69 770.26 282.38 C 767.83 282.8 764.52 283.78 764.52 284.66 L 764.52 282.51 C 764.52 281.55 768.18 280.5 771.26 280.05 C 775.69 279.44 780.84 279.38 785.14 279.86 C 787.86 280.15 790.28 280.7 792 281.42 Z M 792 286.45 L 792 288.88 C 792 289.67 789.31 290.44 787.73 290.7 C 783.15 291.62 775.93 291.5 772.56 290.78 C 770.82 290.47 767.8 289.68 767.8 288.89 L 767.8 286.42 C 767.8 287.34 771.49 288.16 773.24 288.44 C 777.41 289.11 782.91 289.05 787.42 288.31 C 789.4 287.97 792 287.17 792 286.45 Z M 792 308.05 L 792 310.54 C 791.82 311.28 788.37 312.2 786.91 312.35 C 781.91 313.09 775.78 313.19 771.21 312.22 C 769.69 311.9 767.79 311.2 767.8 310.44 L 767.8 308 C 767.8 308.88 770.43 309.65 772.06 309.94 C 776.17 310.6 780.94 310.66 786.29 309.99 C 789.05 309.65 791.85 308.74 792 308.05 Z M 766.44 309.57 L 766.44 311.84 L 742.17 311.84 C 736.94 311.84 732 307.9 732 303.05 L 732 300.79 C 732 305.83 737.08 309.57 742.17 309.57 Z",
    fillOpacity: 0.3,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "none"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 257.39,
    width: 0,
    height: 0,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 773.37 272.24 C 773.87 271.93 773.99 271.19 774.07 270.55 C 774.18 269.54 774.18 267.25 774.04 266.54 C 773.95 265.95 773.78 265.28 773.18 265.06 C 772.66 264.89 772.08 264.98 771.79 265.14 C 771.43 265.36 771.27 265.73 771.18 266.06 C 770.9 267.16 770.96 269.31 771.02 270.32 C 771.11 271.45 771.35 271.95 771.67 272.19 C 772.11 272.53 772.91 272.53 773.37 272.24 Z M 751.26 263.59 L 751.26 273.72 L 749.11 273.72 L 749.11 265.56 L 747.08 273.72 L 745.04 273.72 L 743.01 265.58 L 743 273.72 L 740.84 273.72 L 740.84 263.59 L 744.36 263.59 L 746.05 270.76 L 747.76 263.59 Z M 758.86 266.04 L 756.7 273.29 C 756.17 274.93 755.85 275.79 754.89 276.11 C 754.25 276.32 753.3 276.3 752.41 276.28 L 752.41 274.81 L 753.09 274.81 C 753.93 274.81 754.24 274.37 754.31 273.71 L 751.83 266.04 L 754.1 266.04 L 755.46 271.35 L 756.59 266.04 Z M 765.31 266.44 C 765.31 266.03 765.29 265.6 764.95 265.24 C 764.57 264.89 763.51 264.85 763.03 265.31 C 762.66 265.65 762.59 266.32 762.86 266.79 C 763.25 267.4 764.16 267.57 765.31 268.04 C 765.99 268.31 767.06 268.64 767.65 269.46 C 768.13 270.06 768.21 271.57 767.63 272.53 C 767.08 273.46 765.9 274.08 763.63 274.03 C 762.08 273.96 761.06 273.54 760.53 272.6 C 760.29 272.14 760.17 271.51 760.22 270.68 L 762.59 270.68 C 762.56 271.65 762.82 272.1 763.28 272.29 C 764.01 272.57 764.95 272.52 765.35 271.89 C 765.69 271.39 765.63 270.47 764.99 270.09 C 764.11 269.46 762.82 269.39 761.68 268.75 C 761.06 268.35 760.25 267.82 760.32 266.16 C 760.35 264.99 760.97 263.93 762.57 263.54 C 763.48 263.33 764.87 263.3 765.96 263.71 C 767.3 264.26 767.63 265.26 767.57 266.44 Z M 776.98 273.83 L 775.5 275.01 L 774.15 273.74 C 773.51 273.96 772.44 273.99 771.59 273.84 C 769.95 273.58 769.22 272.63 768.92 271.24 C 768.68 270.09 768.6 268.04 768.87 266.27 C 769.07 265.05 769.63 263.92 771.08 263.5 C 772.15 263.18 773.68 263.26 774.49 263.56 C 775.88 264.06 776.31 265.22 776.5 266.38 C 776.68 267.58 776.68 269.4 776.52 270.82 C 776.37 271.7 776.09 272.32 775.73 272.74 Z M 784.11 273.72 L 777.54 273.72 L 777.54 263.59 L 779.92 263.59 L 779.92 272.06 L 784.11 272.06 Z M 773.47 307.96 L 773.47 295 L 777.11 295 L 779.7 304.54 L 782.3 295 L 785.94 295 L 785.94 307.96 L 783.66 307.96 L 783.66 297.28 L 780.73 307.96 L 778.69 307.96 L 775.75 297.27 L 775.75 307.96 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 320,
      marginLeft: 762
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "nowrap"
    }
  }, "MySQL Master")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 762,
    y: 332,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "MySQL Mast...")))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 816,
    width: 370,
    height: 181.69,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 62,
      height: 1,
      paddingTop: 845,
      marginLeft: 592
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "HID: 20 (Backup Writer)")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 623,
    y: 850,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "middle"
  }, "HID: 20...")))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 731,
    y: 845.99,
    width: 190,
    height: 129.78,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "none"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 805.5,
    y: 868.87,
    width: 90.85,
    height: 90.85,
    xlinkHref: "https://pbs.twimg.com/profile_images/1455857819534647296/kWvczaKh_400x400.jpg",
    preserveAspectRatio: "none",
    pointerEvents: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 805.98 916.05 L 805.98 918.66 C 805.98 919.37 803.95 920.19 801.54 920.66 C 797.51 921.44 791.51 921.55 787.37 920.85 C 784.2 920.33 781.79 919.37 781.79 918.68 L 781.79 916.03 C 781.94 915.2 784.25 914.41 786.79 913.96 C 791.15 913.29 796.36 913.19 801.27 914.02 C 803.04 914.34 805.91 915.13 805.98 916.05 Z M 805.98 941.77 C 805.98 942.53 802.59 943.58 800.27 943.85 C 795.55 944.56 790.37 944.52 786.05 943.79 C 784.04 943.43 781.79 942.6 781.79 941.69 L 781.79 921.09 C 782.56 921.6 783.63 922.26 787.13 922.93 C 790.88 923.67 797.27 923.55 801.15 922.82 C 802.96 922.49 804.82 921.99 805.98 921.32 Z M 780.43 943.2 L 756.29 943.2 C 750.08 943.2 746 938.23 746 933.91 L 746 894.42 C 746 889.58 750.41 885.01 756.24 885.01 L 795.89 885.01 C 801.24 885.01 805.98 889.22 805.98 894.62 L 805.98 913 C 803.93 912.06 801 911.51 797.77 911.2 C 793.6 910.85 787.81 910.89 783.36 911.9 C 781.26 912.37 778.67 913.25 778.51 914.13 L 778.51 939.15 C 778.51 939.86 779.85 940.66 780.43 940.77 Z",
    fill: "#2e73b8",
    stroke: "none",
    pointerEvents: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 805.98 916.05 L 805.98 918.66 C 806 919.37 803.95 920.21 801.54 920.66 C 797.51 921.44 791.51 921.55 787.37 920.85 C 784.2 920.33 781.79 919.37 781.79 918.68 L 781.79 916.03 C 781.91 917.05 785.35 917.88 787.74 918.29 C 790.68 918.8 797.12 918.83 800.74 918.19 C 803.02 917.78 805.83 917.01 805.98 916.05 Z M 805.98 939.15 L 805.98 941.77 C 805.98 942.53 802.59 943.58 800.27 943.85 C 795.53 944.58 790.38 944.53 786.05 943.79 C 784.05 943.43 781.79 942.61 781.79 941.69 L 781.79 939.05 C 781.79 939.99 784.11 940.86 786.76 941.29 C 791.09 941.97 796.21 941.77 800.03 941.25 C 803.05 940.87 805.95 939.85 805.98 939.15 Z M 805.98 913 C 803.93 912.06 801 911.52 797.77 911.2 C 793.58 910.85 787.81 910.91 783.36 911.9 C 781.26 912.37 778.66 913.25 778.51 914.13 L 778.51 911.87 C 778.51 910.98 781.35 910.04 782.99 909.67 C 788.48 908.4 795.11 908.56 798.64 908.97 C 801.86 909.31 804.26 909.9 805.98 910.68 Z M 780.43 943.2 L 756.29 943.2 C 750.08 943.2 746 938.26 746 933.91 L 746 931.15 C 746 936.41 750.67 940.77 756.27 940.77 L 780.43 940.77 Z",
    fillOpacity: 0.3,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "none"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 746,
    y: 885.01,
    width: 0,
    height: 0,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 799.67 929.31 L 796.38 929.31 C 796.33 928.57 796.05 927.84 795.21 927.5 C 794.44 927.15 793.04 927.15 792.56 927.32 C 791.86 927.49 791.32 927.9 791.2 928.48 C 791.06 929.4 791.36 929.66 792.33 930.01 C 793.39 930.35 795.29 930.83 796.42 931.07 C 797.66 931.4 799.01 931.98 799.67 933.32 C 800.24 934.56 800.05 936.05 799.41 936.97 C 798.34 938.74 795.88 939.36 793.6 939.31 C 792.07 939.29 790.31 938.94 788.95 937.83 C 788.18 937.13 787.44 936.13 787.44 934.42 L 790.7 934.42 C 790.74 935.6 791.41 936.37 792.34 936.71 C 793.31 937.1 794.88 937.1 795.91 936.66 C 796.53 936.41 796.98 935.95 796.95 935.22 C 796.88 934.29 795.89 933.9 795.15 933.66 C 793.72 933.21 792.3 933.04 790.82 932.48 C 789.5 931.95 788.21 931.11 788.11 929.27 C 788.08 928.39 788.34 927.49 788.92 926.79 C 789.82 925.61 791.59 924.96 793.36 924.89 C 795.52 924.82 797.28 925.43 798.22 926.21 C 799.44 927.18 799.67 928.44 799.67 929.31 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 792 285.29 L 1000.08 285.23 L 1000.08 910.92 L 931.1 910.88",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 924.35 910.88 L 933.36 906.38 L 931.1 910.88 L 933.35 915.38 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 417,
      marginLeft: 1001
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Write"))))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 1001,
    y: 420,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Write")))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 576,
    width: 180,
    height: 178.14,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 828.09 698.08 L 897.44 698.08 L 897.44 628.73 L 828.09 628.73 Z M 902.06 637.98 L 902.06 647.23 L 913.62 647.23 L 913.62 651.85 L 902.06 651.85 L 902.06 661.1 L 913.62 661.1 L 913.62 665.72 L 902.06 665.72 L 902.06 674.97 L 913.62 674.97 L 913.62 679.59 L 902.06 679.59 L 902.06 688.84 L 913.62 688.84 L 913.62 693.46 L 902.06 693.46 L 902.06 700.4 C 902.06 701.67 901.03 702.71 899.75 702.71 L 892.81 702.71 L 892.81 714.27 L 888.19 714.27 L 888.19 702.71 L 878.94 702.71 L 878.94 714.27 L 874.32 714.27 L 874.32 702.71 L 865.07 702.71 L 865.07 714.27 L 860.45 714.27 L 860.45 702.71 L 851.2 702.71 L 851.2 714.27 L 846.58 714.27 L 846.58 702.71 L 837.33 702.71 L 837.33 714.27 L 832.71 714.27 L 832.71 702.71 L 825.78 702.71 C 824.5 702.71 823.46 701.67 823.46 700.4 L 823.46 693.46 L 811.91 693.46 L 811.91 688.84 L 823.46 688.84 L 823.46 679.59 L 811.91 679.59 L 811.91 674.97 L 823.46 674.97 L 823.46 665.72 L 811.91 665.72 L 811.91 661.1 L 823.46 661.1 L 823.46 651.85 L 811.91 651.85 L 811.91 647.23 L 823.46 647.23 L 823.46 637.98 L 811.91 637.98 L 811.91 633.36 L 823.46 633.36 L 823.46 626.42 C 823.46 625.15 824.5 624.11 825.78 624.11 L 832.71 624.11 L 832.71 612.55 L 837.33 612.55 L 837.33 624.11 L 846.58 624.11 L 846.58 612.55 L 851.2 612.55 L 851.2 624.11 L 860.45 624.11 L 860.45 612.55 L 865.07 612.55 L 865.07 624.11 L 874.32 624.11 L 874.32 612.55 L 878.94 612.55 L 878.94 624.11 L 888.19 624.11 L 888.19 612.55 L 892.81 612.55 L 892.81 624.11 L 899.75 624.11 C 901.03 624.11 902.06 625.15 902.06 626.42 L 902.06 633.36 L 913.62 633.36 L 913.62 637.98 Z M 886.17 672.39 C 887.94 672.39 889.46 672.05 890.74 671.38 L 890.74 668.7 C 889.35 669.13 888.08 669.34 886.92 669.34 C 885.3 669.34 884.11 668.91 883.34 668.05 C 882.58 667.19 882.19 665.85 882.19 664.04 L 882.19 663.61 C 882.19 661.78 882.58 660.43 883.34 659.55 C 884.11 658.68 885.3 658.24 886.92 658.24 C 887.93 658.24 889.16 658.45 890.61 658.86 L 890.61 656.17 C 889.31 655.52 887.88 655.2 886.3 655.2 C 883.78 655.2 881.82 655.97 880.41 657.5 C 879.01 659.03 878.31 661.18 878.31 663.94 C 878.31 666.64 878.99 668.72 880.35 670.18 C 881.71 671.65 883.65 672.39 886.17 672.39 Z M 871.64 665.14 C 870.53 664.9 869.54 664.78 868.68 664.78 C 866.49 664.78 865.4 665.65 865.4 667.4 C 865.4 668.16 865.6 668.74 866.03 669.17 C 866.45 669.59 867.03 669.8 867.76 669.8 C 868.37 669.8 869.01 669.66 869.69 669.39 C 870.36 669.12 871.01 668.74 871.64 668.24 Z M 871.64 662.87 L 871.64 660.96 C 871.64 659.86 871.4 659.1 870.93 658.66 C 870.46 658.23 869.62 658.02 868.44 658.02 C 866.76 658.02 864.82 658.37 862.64 659.08 L 862.64 656.4 C 863.46 655.99 864.45 655.67 865.63 655.43 C 866.8 655.19 867.98 655.07 869.17 655.07 C 871.32 655.07 872.91 655.5 873.93 656.37 C 874.95 657.23 875.46 658.58 875.46 660.41 L 875.46 672.03 L 872.13 672.03 L 871.84 670.44 C 871.08 671.09 870.24 671.6 869.33 671.96 C 868.41 672.33 867.5 672.51 866.59 672.51 C 865.08 672.51 863.86 672.06 862.92 671.16 C 861.98 670.25 861.51 669.07 861.51 667.63 C 861.51 666.03 862.09 664.76 863.24 663.81 C 864.4 662.86 865.95 662.39 867.89 662.39 C 869.03 662.39 870.28 662.55 871.64 662.87 Z M 839.63 672.03 L 836.01 672.03 L 836.01 649.6 L 840.41 649.6 L 847.14 662.97 L 854 649.6 L 858.28 649.6 L 858.28 672.03 L 854.65 672.03 L 854.65 655.23 L 848.83 666.4 L 845.27 666.4 L 839.63 655.3 Z",
    fill: "#d45b07",
    stroke: "none",
    pointerEvents: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 809.89 667.38 L 809.89 670.4 C 809.89 671.21 807.86 672.17 805.45 672.7 C 801.42 673.61 795.42 673.74 791.28 672.93 C 788.11 672.33 785.7 671.21 785.7 670.41 L 785.7 667.35 C 785.85 666.39 788.16 665.49 790.7 664.97 C 795.06 664.19 800.27 664.07 805.18 665.03 C 806.95 665.4 809.82 666.31 809.89 667.38 Z M 809.89 697.1 C 809.89 697.98 806.5 699.2 804.18 699.5 C 799.46 700.33 794.28 700.28 789.96 699.44 C 787.95 699.02 785.7 698.06 785.7 697.01 L 785.7 673.2 C 786.47 673.79 787.54 674.55 791.04 675.33 C 794.79 676.19 801.18 676.04 805.06 675.2 C 806.87 674.82 808.73 674.24 809.89 673.46 Z M 784.34 698.76 L 760.2 698.76 C 753.99 698.76 749.91 693.02 749.91 688.02 L 749.91 642.38 C 749.91 636.78 754.32 631.5 760.15 631.5 L 799.8 631.5 C 805.15 631.5 809.89 636.36 809.89 642.61 L 809.89 663.85 C 807.84 662.76 804.91 662.13 801.68 661.77 C 797.51 661.37 791.72 661.42 787.27 662.58 C 785.17 663.12 782.58 664.14 782.42 665.16 L 782.42 694.07 C 782.42 694.9 783.76 695.82 784.34 695.95 Z",
    fill: "#2e73b8",
    stroke: "none",
    pointerEvents: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 809.89 667.38 L 809.89 670.4 C 809.91 671.21 807.86 672.18 805.45 672.7 C 801.42 673.61 795.42 673.74 791.28 672.93 C 788.11 672.33 785.7 671.21 785.7 670.41 L 785.7 667.35 C 785.82 668.53 789.26 669.49 791.65 669.96 C 794.59 670.56 801.03 670.59 804.65 669.85 C 806.93 669.38 809.74 668.48 809.89 667.38 Z M 809.89 694.07 L 809.89 697.1 C 809.89 697.98 806.5 699.2 804.18 699.5 C 799.44 700.35 794.29 700.3 789.96 699.44 C 787.96 699.02 785.7 698.08 785.7 697.01 L 785.7 693.96 C 785.7 695.04 788.02 696.05 790.67 696.55 C 795 697.33 800.12 697.1 803.94 696.5 C 806.96 696.07 809.86 694.88 809.89 694.07 Z M 809.89 663.85 C 807.84 662.76 804.91 662.14 801.68 661.77 C 797.49 661.37 791.72 661.43 787.27 662.58 C 785.17 663.12 782.57 664.14 782.42 665.16 L 782.42 662.55 C 782.42 661.51 785.26 660.43 786.9 660 C 792.39 658.53 799.02 658.72 802.55 659.19 C 805.77 659.58 808.17 660.26 809.89 661.17 Z M 784.34 698.76 L 760.2 698.76 C 753.99 698.76 749.91 693.05 749.91 688.02 L 749.91 684.83 C 749.91 690.91 754.58 695.95 760.18 695.95 L 784.34 695.95 Z",
    fillOpacity: 0.3,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "none"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 749.91,
    y: 631.5,
    width: 0,
    height: 0,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "none"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 803.58 682.71 L 800.29 682.71 C 800.24 681.85 799.96 681 799.12 680.61 C 798.35 680.21 796.95 680.21 796.47 680.4 C 795.77 680.6 795.23 681.07 795.11 681.75 C 794.97 682.8 795.27 683.11 796.24 683.52 C 797.3 683.91 799.2 684.46 800.33 684.73 C 801.57 685.12 802.92 685.79 803.58 687.34 C 804.15 688.77 803.96 690.49 803.32 691.56 C 802.25 693.6 799.79 694.32 797.51 694.27 C 795.98 694.23 794.22 693.83 792.86 692.55 C 792.09 691.74 791.35 690.59 791.35 688.61 L 794.61 688.61 C 794.65 689.97 795.32 690.86 796.25 691.25 C 797.22 691.7 798.79 691.7 799.82 691.2 C 800.44 690.91 800.89 690.37 800.86 689.53 C 800.79 688.46 799.8 688.01 799.06 687.73 C 797.63 687.21 796.21 687.02 794.73 686.37 C 793.41 685.75 792.12 684.78 792.02 682.66 C 791.99 681.64 792.25 680.6 792.83 679.79 C 793.73 678.42 795.5 677.68 797.27 677.6 C 799.43 677.52 801.19 678.21 802.13 679.12 C 803.35 680.24 803.58 681.7 803.58 682.71 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 1000.08 506 L 1000.08 665.08 L 930.1 665.07",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 923.35 665.07 L 932.35 660.57 L 930.1 665.07 L 932.35 669.57 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 229 380 L 279.9 380",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 286.65 380 L 277.65 384.5 L 279.9 380 L 277.65 375.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 364.33 383.08 L 500.08 383.08 L 500.08 285.23 L 721.9 285.29",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 728.65 285.29 L 719.64 289.79 L 721.9 285.29 L 719.65 280.79 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 285,
      marginLeft: 570
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "Read/Write")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 570,
    y: 290,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "middle"
  }, "Read/Write")))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 364.33 383.08 L 500.08 383.08 L 500.08 665.08 L 729.9 665.07",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 736.65 665.07 L 727.65 669.57 L 729.9 665.07 L 727.65 660.57 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 667,
      marginLeft: 591
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "Read")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 591,
    y: 672,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "middle"
  }, "Read")))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 364.33 383.08 L 500.08 383.08 L 500.08 914.77 L 735.9 914.79",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 742.65 914.79 L 733.65 919.29 L 735.9 914.79 L 733.65 910.29 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 918,
      marginLeft: 600
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "Read/ ", _br || (_br = /*#__PURE__*/React.createElement("br", null)), "(Write if Master fail)")))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 922,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "middle"
  }, "Read/...")))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 341 L 78 341 L 78 419 L 0 419 Z",
    fill: "url(#mx-gradient-f78e04-1-d05c17-1-s-0)",
    stroke: "none",
    pointerEvents: "none"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 25.67 408.97 L 11.83 408.97 L 27.13 376.99 L 34.06 391.26 Z M 28.13 373.93 C 27.94 373.55 27.55 373.3 27.13 373.3 L 27.12 373.3 C 26.69 373.3 26.3 373.55 26.12 373.94 L 9.05 409.61 C 8.89 409.95 8.91 410.36 9.11 410.68 C 9.32 411 9.68 411.2 10.06 411.2 L 26.37 411.2 C 26.8 411.2 27.2 410.95 27.38 410.56 L 36.31 391.73 C 36.46 391.43 36.46 391.07 36.31 390.77 Z M 66.88 408.97 L 53.13 408.97 L 31.08 362.81 C 30.9 362.42 30.5 362.17 30.07 362.17 L 21.08 362.17 L 21.09 351.03 L 38.72 351.03 L 60.67 397.19 C 60.85 397.58 61.25 397.83 61.68 397.83 L 66.88 397.83 Z M 68 395.6 L 62.38 395.6 L 40.43 349.44 C 40.25 349.05 39.85 348.8 39.42 348.8 L 19.97 348.8 C 19.36 348.8 18.86 349.3 18.85 349.91 L 18.84 363.28 C 18.84 363.58 18.96 363.86 19.17 364.07 C 19.38 364.28 19.66 364.4 19.96 364.4 L 29.37 364.4 L 51.42 410.56 C 51.61 410.95 52 411.2 52.43 411.2 L 68 411.2 C 68.61 411.2 69.11 410.7 69.11 410.09 L 69.11 396.71 C 69.11 396.1 68.61 395.6 68 395.6 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "none"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 39 244 L 39 330.9",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 39 337.65 L 34.5 328.65 L 39 330.9 L 43.5 328.65 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 166 L 78 166 L 78 244 L 0 244 Z",
    fill: "url(#mx-gradient-945df2-1-5a30b5-1-s-0)",
    stroke: "none",
    pointerEvents: "none"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 32.39 222.43 L 35.66 222.43 L 35.66 220.19 L 32.39 220.19 Z M 37.89 222.43 L 41.23 222.43 L 41.23 220.19 L 37.89 220.19 Z M 24.53 176.78 L 10.05 183.97 L 10.05 228.62 L 24.53 233.52 Z M 26.75 190.99 L 26.75 220.19 L 30.09 220.19 L 30.09 222.43 L 26.75 222.43 L 26.75 235.08 C 26.75 235.44 26.58 235.78 26.29 235.99 C 26.1 236.13 25.87 236.2 25.64 236.2 C 25.52 236.2 25.4 236.18 25.29 236.14 L 8.59 230.5 C 8.13 230.34 7.83 229.91 7.83 229.43 L 7.83 183.27 C 7.83 182.84 8.07 182.45 8.45 182.26 L 25.15 173.97 C 25.49 173.8 25.9 173.82 26.23 174.03 C 26.55 174.23 26.75 174.59 26.75 174.98 L 26.75 188.75 L 30.09 188.75 L 30.09 190.99 Z M 43.45 222.43 L 46.79 222.43 L 46.79 220.19 L 43.45 220.19 Z M 43.53 190.99 L 46.79 190.99 L 46.79 188.75 L 43.53 188.75 Z M 37.96 190.99 L 41.23 190.99 L 41.23 188.75 L 37.96 188.75 Z M 32.39 190.99 L 35.66 190.99 L 35.66 188.75 L 32.39 188.75 Z M 67.95 183.97 L 53.47 176.78 L 53.47 233.52 L 67.95 228.62 Z M 70.17 229.43 C 70.17 229.91 69.87 230.34 69.41 230.5 L 52.71 236.14 C 52.6 236.18 52.48 236.2 52.36 236.2 C 52.13 236.2 51.9 236.13 51.71 235.99 C 51.42 235.78 51.25 235.44 51.25 235.08 L 51.25 222.43 L 49.09 222.43 L 49.09 220.19 L 51.25 220.19 L 51.25 190.99 L 49.09 190.99 L 49.09 188.75 L 51.25 188.75 L 51.25 174.98 C 51.25 174.59 51.45 174.23 51.77 174.03 C 52.1 173.82 52.51 173.8 52.85 173.97 L 69.55 182.26 C 69.93 182.45 70.17 182.84 70.17 183.27 Z M 42.27 198.13 L 40.19 197.33 L 34.62 211.92 L 36.7 212.73 Z M 49.81 205.26 C 50.24 204.82 50.24 204.11 49.81 203.67 L 45.35 199.18 L 43.78 200.77 L 47.45 204.47 L 43.78 208.16 L 45.35 209.75 Z M 32.65 209.75 L 28.19 205.26 C 27.76 204.82 27.76 204.11 28.19 203.67 L 32.65 199.18 L 34.22 200.77 L 30.55 204.47 L 34.22 208.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "none"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 39.46 63 L 39.46 114.46 L 39.09 155.9",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 39.03 162.65 L 34.61 153.61 L 39.09 155.9 L 43.61 153.69 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 39.45 29.18 C 32.63 29.18 26.26 23.9 26.26 15.72 L 26.27 12.82 C 26.27 6.21 32.05 0 39.49 0 C 46.71 0 52.61 5.84 52.61 13.13 L 52.61 16 C 52.61 22.96 47.13 29.18 39.45 29.18 Z M 62 63 L 53.4 63 L 53.4 51.27 L 51.95 51.27 L 51.95 63 L 27.39 63 L 27.39 51.27 L 25.93 51.27 L 25.93 63 L 17 63 L 17 43.23 C 17 35.32 23.71 30.08 31.87 30.08 L 47.28 30.08 C 54.88 30.08 62 35.07 62 43.35 Z",
    fill: "#d2d3d3",
    stroke: "none",
    pointerEvents: "none"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 25.93 63 L 17 63 L 17 60.18 L 25.93 60.18 Z M 27.39 51.27 L 25.93 51.27 L 25.93 48.46 L 27.39 48.46 Z M 51.95 63 L 27.39 63 L 27.39 60.18 L 51.95 60.18 Z M 53.4 51.27 L 51.95 51.27 L 51.95 48.46 L 53.4 48.46 Z M 62 63 L 53.4 63 L 53.4 60.18 L 62 60.18 Z M 39.45 29.18 C 32.65 29.18 26.26 23.89 26.26 15.72 L 26.27 13.07 C 26.27 21.56 33.27 26.37 39.46 26.37 C 46.79 26.37 52.61 20.42 52.61 13.13 L 52.61 16 C 52.61 22.91 47.16 29.18 39.45 29.18 Z",
    fillOpacity: 0.3,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "none"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 78 380 L 160 380",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 587,
      marginLeft: 191
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "On-Perm")))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 235,
    y: 591,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "On-Perm"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseArch);
export default __webpack_public_path__ + "static/media/database-arch.db4b8ea67bbc57d54898305e18918ff4.svg";
export { ForwardRef as ReactComponent };